export const autocomplete = {
  overlay: {
    background: 'rgb(255, 255, 255)',
    borderColor: 'rgb(226, 232, 240)',
    borderRadius: '1rem',
    color: 'rgb(31, 41, 55)',
    shadow: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
  },
  css: ({ dt }: any) => `
    @media (max-width: 600px) {
      .p-autocomplete-input {
        letter-spacing: -0.025em;
      }
    }
  `,
};
